import React, { Component, PropTypes as pt } from 'react';

import MdPhotoSizeSelectActual from 'react-icons/lib/md/photo-size-select-actual';

import AssetListing from '../../../metadata/components/assets/AssetsListing';

import Modal from '../../../common/components/Modal';

class FallbackImageSelect extends Component {
    constructor (props) {
        super(props);

        this.state = {
            modal: false,
            edited: false,
            value: props.value ? props.value : ""
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.assignAssetAsFallback = this.assignAssetAsFallback.bind(this);
    }

    toggleModal () {
        this.setState({
            modal: !this.state.modal
        });
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    assignAssetAsFallback (asset) {
        const value = asset.fileUrl;
        this.setState({
            value: value,
            edited: true
        });
        this.props.storeEdits(value);
        this.toggleModal();
    }

    render () {
        const value = (this.state.edited) ? this.state.value : this.props.value || "";

        return (<div>
            <div className="input-group">
                <span className="input-group-btn">
                    <button className="btn btn-primary" onClick={this.toggleModal}>
                        <MdPhotoSizeSelectActual/> Select Image &hellip;
                    </button>
                </span>
                <input
                    type="text"
                    value={value}
                    readOnly={true}
                    className="form-control"
                    placeholder="No Fallback Image Selected"/>
            </div>

            {this.renderModal()}
        </div>);
    }

    renderModal () {
        if (this.state.modal) {

            const { assets } = this.props;

            return (<Modal
                cancelModal={this.toggleModal}>
                <Modal.Header>
                    Select a Fallback Image
                </Modal.Header>
                <Modal.Body>
                    <AssetListing
                        mode="assign-fallback"
                        actions={this.props.actions}
                        data={assets}
                        assignAssetAsFallback={this.assignAssetAsFallback}
                    />
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>)
        }
    }
}

FallbackImageSelect.propTypes = {};

export default FallbackImageSelect;
